import { ref, computed } from 'vue';

/**
 * Composable pour gérer la version de l'application
 */
export function useAppVersion() {
    // Version depuis package.json
    const packageVersion = ref(import.meta.env.VITE_APP_VERSION || '0.1.1');

    // Build number depuis les variables d'environnement ou par défaut
    const buildNumber = ref(import.meta.env.VITE_BUILD_NUMBER || '1');

    // Version complète avec build number
    const fullVersion = computed(() => {
        return `${packageVersion.value} (${buildNumber.value})`;
    });

    // Version courte (sans build number)
    const shortVersion = computed(() => {
        return packageVersion.value;
    });

    return {
        packageVersion,
        buildNumber,
        fullVersion,
        shortVersion
    };
}
